<template>
  <DashboardMenu />
  <div class="container">
    <div class="col-12">
      <h1 class="h1">Доноры</h1>
    </div>

    <div class="stats-columns">
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ donorsCount }}</div>
            <div class="card__subhead">Доноров в системе</div>
            <!---->
          </div>
        </div>
      </div>
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ proceededChecksCount }}</div>
            <div class="card__subhead">Обработано запросов</div>
            <!---->
          </div>
        </div>
      </div>
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ activeDonorsCount }}</div>
            <div class="card__subhead">Активных доноров</div>
            <!---->
          </div>
          <!-- <div class="mdc-card-wrapper__text-section">
            <div class="card__supporting-text">
              Greyhound divisively hello coldly wonderfully marginally far upon
              excluding.
            </div>
          </div> -->
        </div>
      </div>
      <div class="stats-column">
        <div class="mdc-card demo-card">
          <div class="mdc-card-wrapper__text-section">
            <!---->
            <div class="card__title">{{ disabledDonorsCount }}</div>
            <div class="card__subhead">Неактивных доноров</div>
            <!---->
          </div>
        </div>
      </div>
    </div>

    <div style="display: flex; flex-direction: row" class="select-mode-row">
      <p style="margin-right: 15px">Режим просмотра аккаунтов:</p>
      <select v-model="viewMode">
        <option value="all">Все аккаунты</option>
        <option value="active">Только активные</option>
        <option value="inactive">Только неактивные</option>
      </select>
    </div>

    <div class="mdc-card">
      <!-- <div class="card"> -->
      <!-- <div class="card-body"> -->
      <div class="mdc-data-table">
        <div class="mdc-data-table__table-container">
          <table class="mdc-data-table__table" aria-label="Donors List">
            <thead>
              <tr class="mdc-data-table__header-row">
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Id
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Статус
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Шоп
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Логин
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Пароль
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Чеков
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Добавлен
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Обновлен
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Proxy
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  UserAgent
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  2FA
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  dtsg Token
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Cookies
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Cookies Json
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Access Token
                </th>
                <th
                  class="mdc-data-table__header-cell"
                  role="columnheader"
                  scope="col"
                >
                  Действия
                </th>
              </tr>
            </thead>
            <tbody class="mdc-data-table__content" v-if="viewMode === 'active'">
              <tr
                class="mdc-data-table__row"
                v-for="(donor, i) in activeDonors"
                :key="i"
              >
                <th class="mdc-data-table__cell" scope="row">
                  <router-link :to="'/dashboard/donors/' + donor.id + '/'">{{
                    donor.id
                  }}</router-link>
                </th>
                <td class="mdc-data-table__cell">{{ donor.status ? 'Активен' : 'Заблокирован' }}</td>
                <td class="mdc-data-table__cell">{{ donor.shop ? donor.shop : 'Не указан' }}</td>
                <td class="mdc-data-table__cell">{{ donor.login }}</td>
                <td class="mdc-data-table__cell">{{ donor.password }}</td>
                <td class="mdc-data-table__cell">{{ donor.checksCount }}</td>
                <td class="mdc-data-table__cell">
                  {{ moment(donor.createdAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ moment(donor.updatedAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">{{ donor.proxy ? '✔' : '✕' }}</td>
                <td class="mdc-data-table__cell">{{ donor.userAgent ? '✔' : '✕' }}</td>
                <td class="mdc-data-table__cell">
                  {{ donor.twoFA ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.dtsgToken ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.cookie ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.cookieJson ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.accessToken ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  <router-link :to="'/dashboard/donors/' + donor.id + '/'"
                    >Details</router-link
                  >
                </td>
              </tr>
            </tbody>
            <tbody class="mdc-data-table__content" v-else-if="viewMode === 'inactive'">
              <tr
                class="mdc-data-table__row"
                v-for="(donor, i) in disabledDonors"
                :key="i"
                :class="donor.status ? 'success' : 'danger'"
              >
                <th class="mdc-data-table__cell" scope="row">
                  <router-link :to="'/dashboard/donors/' + donor.id + '/'">{{
                    donor.id
                  }}</router-link>
                </th>
                <td class="mdc-data-table__cell">{{ donor.status ? 'Активен' : 'Заблокирован' }}</td>
                <td class="mdc-data-table__cell">{{ donor.shop ? donor.shop : 'Не указан' }}</td>
                <td class="mdc-data-table__cell">{{ donor.login }}</td>
                <td class="mdc-data-table__cell">{{ donor.password }}</td>
                <td class="mdc-data-table__cell">{{ donor.checksCount }}</td>
                <td class="mdc-data-table__cell">
                  {{ moment(donor.createdAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ moment(donor.updatedAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">{{ donor.proxy ? '✔' : '✕' }}</td>
                <td class="mdc-data-table__cell">{{ donor.userAgent ? '✔' : '✕' }}</td>
                <td class="mdc-data-table__cell">
                  {{ donor.twoFA ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.dtsgToken ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.cookie ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.cookieJson ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.accessToken ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  <router-link :to="'/dashboard/donors/' + donor.id + '/'"
                    >Details</router-link
                  >
                </td>
              </tr>
            </tbody>
            <tbody class="mdc-data-table__content" v-else>
              <tr
                class="mdc-data-table__row"
                v-for="(donor, i) in donors"
                :key="i"
              >
                <th class="mdc-data-table__cell" scope="row">
                  <router-link :to="'/dashboard/donors/' + donor.id + '/'">{{
                    donor.id
                  }}</router-link>
                </th>
                <td class="mdc-data-table__cell">{{ donor.status ? 'Активен' : 'Заблокирован' }}</td>
                <td class="mdc-data-table__cell">{{ donor.shop ? donor.shop : 'Не указан' }}</td>
                <td class="mdc-data-table__cell">{{ donor.login }}</td>
                <td class="mdc-data-table__cell">{{ donor.password }}</td>
                <td class="mdc-data-table__cell">{{ donor.checksCount }}</td>
                <td class="mdc-data-table__cell">
                  {{ moment(donor.createdAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ moment(donor.updatedAt).fromNow() }}
                </td>
                <td class="mdc-data-table__cell">{{ donor.proxy ? '✔' : '✕' }}</td>
                <td class="mdc-data-table__cell">{{ donor.userAgent ? '✔' : '✕' }}</td>
                <td class="mdc-data-table__cell">
                  {{ donor.twoFA ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.dtsgToken ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.cookie ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.cookieJson ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  {{ donor.accessToken ? '✔' : '✕' }}
                </td>
                <td class="mdc-data-table__cell">
                  <router-link :to="'/dashboard/donors/' + donor.id + '/'"
                    >Details</router-link
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav> -->
    </div>
    <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';
import moment from 'moment';

export default {
  data() {
    return {
      donors: [],
      active: 0,
      viewMode: 'all'
    };
  },
  created: function() {
    this.moment = moment;
  },
  computed: {
    activeDonors: function() {
      return this.donors.filter(d => d.status === true);
    },
    disabledDonors: function() {
      return this.donors.filter(d => d.status === false);
    },
    donorsCount: function() {
      return this.donors.length
    },
    activeDonorsCount: function() {
      return this.activeDonors.length
    },
    disabledDonorsCount: function() {
      return this.disabledDonors.length
    },
    proceededChecksCount: function() {
      return this.donors.reduce((total, currentValue) => { return total + currentValue.checksCount }, 0)
    }
  },

  methods: {
    async getDonors() {
      try {
        const token = localStorage.getItem('adminAuthToken');
        const resp = await this.axios.get('donors', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log(resp);
        this.donors = resp.data;
      } catch (err) {
        console.log(err);
      }
    },
    
  },

  mounted() {
    this.getDonors();
  },
  components: { DashboardMenu }
};
</script>

<style lang="scss" scoped>
@import '../styles/material-components-web.min.css';

.container {
  flex-direction: column;
  width: 1280px;
  max-width: 90%;
  margin: 0 auto;
}

.mdc-data-table__header-cell {
  height: 56px;
  font-weight: bold;
}

.stats-columns {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.stats-column {
  width: 25%;
  padding: 10px;
}

.mdc-card-wrapper__text-section {
  padding: 16px;
}

.card__title {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  text-decoration: inherit;
  text-transform: inherit;
}

.card__subhead {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.card__supporting-text {
  font-family: 'Ubuntu', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  text-decoration: inherit;
  text-transform: inherit;
  opacity: 0.6;
}

.select-mode-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

select {
  padding: 8px 12px;
  border: 1px solid #333;
  opacity: 0.6;
  font-size: 0.875rem;
  line-height: 1.25rem;
   letter-spacing: 0.0178571429em;
}
// .danger {
//   background: rgb(240, 128, 128, 0.7);
// }

// .success {
//   background: rgba(144, 238, 144, 0.7);
// }
.mdc-data-table__table {
  display: block;
  max-height: 430px;
  overflow-y: scroll;
}
</style>